var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoansDisbursedInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 15,
    viewBox: "0 0 32 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.60938H20.3478",
    stroke: "#4F4F4D",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1H20.3478",
    stroke: "#4F4F4D",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3478 1C15.2473 1 16.1098 1.3573 16.7458 1.99329C17.3818 2.62928 17.7391 3.49187 17.7391 4.3913C17.7391 5.29073 17.3818 6.15333 16.7458 6.78932C16.1098 7.42531 15.2473 7.78261 14.3478 7.78261H12L17.7391 13",
    stroke: "#4F4F4D",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1304 1.5L30.1304 6L25.1304 10.5",
    stroke: "#4F4F4D",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5L1 6L6 10.5",
    stroke: "#4F4F4D",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoansDisbursedInactive);
export default __webpack_public_path__ + "static/media/loans-disbursed-inactive.d3b77b6cca3f18105edf892d9867914b.svg";
export { ForwardRef as ReactComponent };